import React, { useState } from 'react'

function App() {
  const [count, setCount] = useState(0)

  return (
    <div style={{ padding: '20px', fontFamily: 'sans-serif' }}>
      <h1>React in Docker</h1>
      <button onClick={() => setCount(count + 1)}>
        Count fwaefis: {count}
      </button>
    </div>
  )
}

export default App
